// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"91":"493ee4694a09af52d2b9","238":"45e6953aec7b5e871e26","501":"8b3d7c1d4a0e27d5190f","700":"e94fd7801a14350d96b5","835":"8222b79f63d512f2cbdb","938":"39f6e63487540b41e138","960":"14e8a3de706610286aaa"}[chunkId] + ".js";
};